import { useEffect, useState } from 'react'
import { SmartSelect } from '../../generic/smartSelect'
import SmartDialog from '../../generic/utilities/SmartDialog/SmartDialog'
import { apiGet, apiPost } from '../../generic/Api_Functions'
import { AddCircleOutlineRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import createDialogTitle from '../../generic/utilities/dialogUtil'
import { Stack, TextField } from '@mui/material'
import AlertUI from '../../generic/AlertUI'
import { formatCodeName } from '../../generic/utilities/objectStructures/codeNameFormat'

const WorkflowPartReference = (props) => {
  const { selectedTemplate, setSelectedTemplate, reload, workflowName, setWorkflowName } = props
  const [templateList, setTemplateList] = useState([])
  const { t_ } = useSmartTranslation()

  useEffect(() => {
    const loadTemplates = async () => {
      setTemplateList(await apiGet('getAllTemplateWorkflows'))
      setWorkflowName('')
    }
    if (!reload) {
      return
    }
    loadTemplates()
  }, [reload, setWorkflowName])

  // RN01.6 (HU-01): templates are identified by code (the renamed historical name); the new
  // free-text "name" is usually empty, so labelling the options by it rendered the whole
  // dropdown blank — same fix as the nodes palette (formatCodeName).
  const templateLabel = (item) => formatCodeName(item?.code, item?.name)

  return (
    <Stack sx={{ marginTop: '1rem' }} gap={3}>
      <SmartSelect
        value={selectedTemplate ? templateLabel(selectedTemplate) : undefined}
        label={t_('Template')}
        sortValues={false}
        selectableOptions={templateList.map((item) => templateLabel(item))}
        onChange={(newItemLabel) => {
          const selected = templateList.find((item) => templateLabel(item) === newItemLabel)
          setSelectedTemplate(selected)
          if (selected) {
            setWorkflowName(selected.code)
          }
        }}
        disableClearable={false}
        autoSelectFirst={false}
      />
      <TextField
        label={t_('Name')}
        value={workflowName}
        onChange={(e) => setWorkflowName(e.target.value)}
      />
    </Stack>
  )
}

const WorkflowPartReferenceDialog = (props) => {
  const { open, closeDialog, partReference, loadWorkflow, onWorklowNameChange, toggleResetSelectedRow } = props
  const { t_ } = useSmartTranslation()
  const [selectedTemplate, setSelectedTemplate] = useState()
  const [workflowName, setWorkflowName] = useState('')
  const [AlertElement, showAlert] = AlertUI()

  const accept = async (template) => {
    // Name cannot be empty
    if (!workflowName || workflowName.trim().length === 0) {
      // Check if workflow name exists in repository

      showAlert({
        title: '',
        message: t_('Workflow name cannot be empty'),
        severity: 'error'
      })
      return
    }

    if (!template || !template.id) {
      toggleResetSelectedRow()
      onWorklowNameChange(workflowName)
      closeDialog()
      return
    }

    const request = { partReferenceId: partReference.id, templateWorkflowId: template.id, workflowName }
    await apiPost('workflows/createWorkflowPartReference', request).then((response) => {
      loadWorkflow(response.id, false)
      closeDialog()
    }).catch((e) => {
      showAlert({
        title: '',
        message: e.message,
        severity: 'error'
      })
    })
  }

  useEffect(() => {
    setSelectedTemplate(null)
  }, [open])
  return (
    <SmartDialog
      setOpen={open}
      cancelCallback={closeDialog}
      acceptCallback={() => accept(selectedTemplate && selectedTemplate.id ? selectedTemplate : null)}
      title={createDialogTitle({ icon: AddCircleOutlineRounded, title: t_('Create new workflow') })}
      renderComponent={
        <Stack>
          {AlertElement}
          <WorkflowPartReference
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            reload={open}
            workflowName={workflowName}
            setWorkflowName={setWorkflowName}
          />
        </Stack>
    }
    />
  )
}

export default WorkflowPartReferenceDialog
